import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type TestUserType = {
  created_at: string;
  email: string;
  nickname: string;
  external_id: string;
  id: number;
  phone: string;
  updated_at: string;
};

export type TestUsersResponseType = TestUserType[];

export const useGetTestUsers = (
  channel?: 'sms' | 'push',
  options: QueryOptions<TestUsersResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<TestUsersResponseType> => {
      const { data } = await api.get<ApiResponse<TestUsersResponseType>>(
        `/campaign/test-user/list${channel ? `?channel=${channel}` : ''}`
      );

      return data.data;
    },
    queryKey: ['test-users', channel],
    ...options,
  });
